import React from "react";
import { useTranslation } from "react-i18next";
import ButtonComponent from "../../../components/ButtonComponent";
import { ReactComponent as UnitedKingdom } from "../../../assets/images/flags/united-kingdom.svg";
import { ReactComponent as Spain } from "../../../assets/images/flags/spain.svg";
import { ReactComponent as Turkey } from "../../../assets/images/flags/turkey.svg";
import { ReactComponent as Iran } from "../../../assets/images/flags/iran.svg";
import { COLORS } from "../../../lib/colors";
import classes from "./index.module.scss";

function Index() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    let previusLanguage = localStorage.getItem("language");

    if (lng === "fa" && previusLanguage !== "fa") {
      i18n.changeLanguage(lng);
      localStorage.setItem("language", lng);
      window.location.reload();
    } else if (previusLanguage === "fa" && lng !== "fa") {
      i18n.changeLanguage(lng);
      localStorage.setItem("language", lng);
      window.location.reload();
    } else {
      i18n.changeLanguage(lng);
      localStorage.setItem("language", lng);
    }
  };
  return (
    <div className={classes.mainContainer}>
      <h3 className={classes.title}>
        {t("pages.protectedPages.patientSettings.title")}
      </h3>
      <hr></hr>
      <div className={classes.btnContainer}>
        <ButtonComponent
          className={classes.languageBtn}
          backgroundColor={COLORS.primary}
          // width={140}
          onClick={() => {
            changeLanguage("en");
            localStorage.setItem("language", "en");
          }}
          icon={<UnitedKingdom width={30} height={30} />}
        >
          <span className={classes.langName}>
            {t("pages.protectedPages.patientSettings.en")}
          </span>
        </ButtonComponent>
        <ButtonComponent
          className={classes.languageBtn}
          backgroundColor={COLORS.primary}
          // width={140}
          onClick={() => changeLanguage("es")}
          icon={<Spain width={30} height={30} />}
        >
          <span className={classes.langName}>
            {t("pages.protectedPages.patientSettings.es")}
          </span>
        </ButtonComponent>
        <ButtonComponent
          className={classes.languageBtn}
          backgroundColor={COLORS.primary}
          // width={140}
          onClick={() => changeLanguage("tr")}
          icon={<Turkey width={30} height={30} />}
        >
          <span className={classes.langName}>
            {t("pages.protectedPages.patientSettings.tr")}
          </span>
        </ButtonComponent>
        <ButtonComponent
          className={classes.languageBtn}
          backgroundColor={COLORS.primary}
          // width={140}
          onClick={() => {
            changeLanguage("fa");
            localStorage.setItem("language", "fa");
          }}
          icon={<Iran width={30} height={30} />}
        >
          <span className={classes.langName}>
            {t("pages.protectedPages.patientSettings.fa")}
          </span>
        </ButtonComponent>
      </div>
    </div>
  );
}

export default Index;
